/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorModel,
  GetAccountOutputBody,
  ListAccountLeagueInvitesOutputBody,
  ListAccountsOutputBody,
  UpdateAccountOutputBody,
  UpdateAccountRequest,
} from '../models/index';
import {
    ErrorModelFromJSON,
    ErrorModelToJSON,
    GetAccountOutputBodyFromJSON,
    GetAccountOutputBodyToJSON,
    ListAccountLeagueInvitesOutputBodyFromJSON,
    ListAccountLeagueInvitesOutputBodyToJSON,
    ListAccountsOutputBodyFromJSON,
    ListAccountsOutputBodyToJSON,
    UpdateAccountOutputBodyFromJSON,
    UpdateAccountOutputBodyToJSON,
    UpdateAccountRequestFromJSON,
    UpdateAccountRequestToJSON,
} from '../models/index';

export interface GetAccountRequest {
    id: string;
}

export interface ListAccountLeagueInvitesRequest {
    id: string;
    f?: string;
    p?: string;
    s?: string;
}

export interface ListAccountsRequest {
    f?: string;
    p?: string;
    s?: string;
}

export interface UpdateAccountOperationRequest {
    id: string;
    updateAccountRequest: Omit<UpdateAccountRequest, '$schema'>;
}

/**
 * 
 */
export class AccountsApi extends runtime.BaseAPI {

    /**
     * Creates request options for getAccount without sending the request
     */
    async getAccountRequestOpts(requestParameters: GetAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get an account by ID
     * Get Account
     */
    async getAccountRaw(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountOutputBody>> {
        const requestOptions = await this.getAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountOutputBodyFromJSON(jsonValue));
    }

    /**
     * Get an account by ID
     * Get Account
     */
    async getAccount(requestParameters: GetAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountOutputBody> {
        const response = await this.getAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listAccountLeagueInvites without sending the request
     */
    async listAccountLeagueInvitesRequestOpts(requestParameters: ListAccountLeagueInvitesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling listAccountLeagueInvites().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['f'] != null) {
            queryParameters['f'] = requestParameters['f'];
        }

        if (requestParameters['p'] != null) {
            queryParameters['p'] = requestParameters['p'];
        }

        if (requestParameters['s'] != null) {
            queryParameters['s'] = requestParameters['s'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/{id}/league-invites`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get an account by ID
     * Get Account
     */
    async listAccountLeagueInvitesRaw(requestParameters: ListAccountLeagueInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAccountLeagueInvitesOutputBody>> {
        const requestOptions = await this.listAccountLeagueInvitesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAccountLeagueInvitesOutputBodyFromJSON(jsonValue));
    }

    /**
     * Get an account by ID
     * Get Account
     */
    async listAccountLeagueInvites(requestParameters: ListAccountLeagueInvitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAccountLeagueInvitesOutputBody> {
        const response = await this.listAccountLeagueInvitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listAccounts without sending the request
     */
    async listAccountsRequestOpts(requestParameters: ListAccountsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['f'] != null) {
            queryParameters['f'] = requestParameters['f'];
        }

        if (requestParameters['p'] != null) {
            queryParameters['p'] = requestParameters['p'];
        }

        if (requestParameters['s'] != null) {
            queryParameters['s'] = requestParameters['s'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List and search for accounts
     * List Accounts
     */
    async listAccountsRaw(requestParameters: ListAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAccountsOutputBody>> {
        const requestOptions = await this.listAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAccountsOutputBodyFromJSON(jsonValue));
    }

    /**
     * List and search for accounts
     * List Accounts
     */
    async listAccounts(requestParameters: ListAccountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAccountsOutputBody> {
        const response = await this.listAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateAccount without sending the request
     */
    async updateAccountRequestOpts(requestParameters: UpdateAccountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAccount().'
            );
        }

        if (requestParameters['updateAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'updateAccountRequest',
                'Required parameter "updateAccountRequest" was null or undefined when calling updateAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/accounts/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAccountRequestToJSON(requestParameters['updateAccountRequest']),
        };
    }

    /**
     * Update an account by ID
     * Update Account
     */
    async updateAccountRaw(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateAccountOutputBody>> {
        const requestOptions = await this.updateAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateAccountOutputBodyFromJSON(jsonValue));
    }

    /**
     * Update an account by ID
     * Update Account
     */
    async updateAccount(requestParameters: UpdateAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateAccountOutputBody> {
        const response = await this.updateAccountRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
